var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center"},[_c('vs-avatar',{staticClass:"flex-shrink-0 mr-2",attrs:{"src":_vm.params.data.pictureUrl,"size":"30px"}}),_vm._v("\n  "+_vm._s(_vm.params.value)+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }